import {SearchConditions} from '../types';
import {MapDetail} from './MapDetail';

interface MapDetailsProps {
  mapList: string[];
  searchConditions: SearchConditions | null;
  xTimeliles: string[];
}

export const MapDetails = ({mapList, searchConditions, xTimeliles}: MapDetailsProps) => {
  if (!searchConditions) return null;

  return (
    <>
      {mapList.map((map: string) => (
        <MapDetail
          key={`MapDetail-${map}`}
          searchConditions={searchConditions}
          selectedMap={map}
          xTimeliles={xTimeliles}
        />
      ))}
    </>
  );
};
